// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-table-container] {\n  width: 700px;\n  height: 395px; }\n", "",{"version":3,"sources":["webpack://src/pages/MeusConteudos/components/ResultConvitesPendentesData/styles.scss"],"names":[],"mappings":"AAAA;EACI,YAAY;EACZ,aAAa,EAAA","sourcesContent":["[data-table-container]{\n    width: 700px;\n    height: 395px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
